import React from "react";

const Timeline = (/** @type {{children: React.ReactNode}} */ props) => {
    return <div className='timeline3'>
        {props.children}
    </div>
}

export const TimelineStep = (/** @type {{title:string; content: React.ReactNode;}} */ props) => {
    return <div className="timeline3__section" key={props.title}>
        <div className='timeline3__indicator'>
            <div className='timeline3__bar'/>
        </div>
        <div className='timeline3__label-wrapper'>
            <h1>{props.title}</h1>
            <>{props.content}</>
        </div>
    </div>
}

export default Timeline